import {Injectable} from '@angular/core';
import {ReadableAllById} from '../../../../core/interfaces/base-service.interfaces';
import {VehicleAvailableKeyNumberResponse} from '../model/vehicle-available-key-number.response';
import {Observable} from 'rxjs';
import {BaseService} from '../../../../core/abstracts/base-service.abstract';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class KeyNumberService extends BaseService implements ReadableAllById<VehicleAvailableKeyNumberResponse> {
  protected override endpoint: string = '/storages';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getAll(id: number | string): Observable<VehicleAvailableKeyNumberResponse[]> {
    return this.get<VehicleAvailableKeyNumberResponse[]>(`${id}/keys`);
  }
}
